import React from "react"

import solar from "../assets/solar.png"
import stellar from "../assets/stellar.png"
import galactical from "../assets/galactical.png"

export const cubesData = [
  {
    text: "solar",
    svg: solar,
    number: "1234.56",
    background: "90deg, rgba(241, 90, 41, 0) 0%, #532920 62%, #292930 100%",
    color: "#C9D8C5",
    dotBackground: "178.89deg, #28A909 14.22%, #309B17 69.01%, #208707 99.05%",
    dotInactiveBackground: "#2A2124",
    dotShadow: "inset 0.1px 0.1px 1px #2B9411",
    numberColor: "linear-gradient(27.03deg, #B6961E 29.02%, #FFCB05 84%)",
    activated: 0,
  },
  {
    text: "galactical",
    svg: galactical,
    number: "1234.56",
    background: "90deg, rgba(68, 67, 243, 0 ) 0%, #36366A 62%, #292930 100%",
    color: "#C6BEF4",
    dotBackground: "178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%",
    dotInactiveBackground: "#20202A",
    dotShadow: "inset 0.1px 0.1px 1px #2B4ED9",
    numberColor: "linear-gradient(27.03deg, #4646F3 29.02%, #767EF8 84%)",
    activated: 0,
  },
  {
    text: "stellar",
    svg: stellar,
    number: "1234.56",
    background: "90deg, rgba(223, 67, 67, 0) 0%, #873841 62%, #292930 100%",
    color: "#D9BFC0",
    dotBackground: "178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%",
    dotInactiveBackground: "#2D2126",
    dotShadow: "inset 0.1px 0.1px 1px #EB3636",
    numberColor: "linear-gradient(27.03deg, #DF4444 29.02%, #EC6363 84%)",
    activated: 0,
  },
]
